import { AxiosRequestConfig } from "axios";

export const postLoginGoogleConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/oauth",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
